import React, { Component } from 'react';
import Header from './../../containers/HeaderContainer';
import GameWrapperContainer from '../../containers/GameWrapperContainer';
import MailThreadContainer from '../../containers/mailThreadContainer/MailThreadContainer';
import MailHeaderContainer from '../../containers/mailHeaderContainer';
import Footer from './../../containers/FooterContainer';
import analyticsUtil from '../../utils/segmentUtils';

class ViewMail extends Component {
    componentDidMount() {
        analyticsUtil.page('View mail page')
    }

    render() {
        const isMailThreadView = true;
        return <GameWrapperContainer match={this.props.match}>
            <Header {...this.props} />
            <div className="mail-container">
                <MailHeaderContainer {...this.props} isMailThreadView={isMailThreadView} />
                <MailThreadContainer {...this.props} />
            </div>
            <Footer {...this.props} />
        </GameWrapperContainer>;
    }
}
export default ViewMail;


// WEBPACK FOOTER //
// /src/screens/ViewMail/index.js